import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import Button from 'material-ui/Button'

import { setStage } from 'modules/users/otp'
import jsonSelector from 'selectors/json'

const BackupCodes = ({ setStage, open, codes }) => (
  <Dialog open={open} onClose={() => setStage('')}>
    <DialogTitle>2-Step Verification backup codes</DialogTitle>
    <DialogContent>
      <p className="text-justify">
        Should you ever lose your phone, each of these recovery codes can be used one time each to
        regain access to your account.
      </p>
      <p className="text-justify">
        Keep these codes in a <b>safe place</b>:
      </p>
      <ul id="step3-backup-codes">
        {Array.isArray(codes) && codes.map(code => <li key={code}>{code}</li>)}
      </ul>
    </DialogContent>
    <Divider light />
    <DialogActions>
      <Button onClick={() => setStage(0)}>Close</Button>
    </DialogActions>
  </Dialog>
)

const mapStateToProps = state => ({
  open: state.users.otp.stage === 'backup_codes',
  codes: jsonSelector('users.otp')(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ setStage }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(BackupCodes)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/edit/backup_codes.js